import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const ChargeCable = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <g fillRule="evenodd" clipRule="evenodd">
        <path d="M10.336 3.974c0-.184.15-.333.333-.333h4c.184 0 .333.149.333.333v6.666c0 .184-.149.334-.333.334h-4a.333.333 0 0 1-.333-.334V3.974Zm.667.333v6h3.333v-6h-3.333ZM3.335 11.973c.184 0 .334.149.334.333v3.333h8.666v-3.333a.333.333 0 1 1 .667 0v3.667c0 .184-.15.333-.334.333H3.335a.333.333 0 0 1-.333-.334v-3.666c0-.184.15-.333.333-.333Z" />
        <path d="M11.002 1.974c0-.184.15-.333.333-.333h2.667c.184 0 .333.149.333.333v2a.333.333 0 1 1-.666 0V2.307h-2v1.667a.333.333 0 1 1-.667 0v-2ZM1.002 3.974c0-.184.15-.333.333-.333h4c.184 0 .334.149.334.333v6.666c0 .184-.15.334-.334.334h-4a.333.333 0 0 1-.333-.334V3.974Zm.667.333v6h3.333v-6H1.669Z" />
        <path d="M1.668 1.974c0-.184.15-.333.333-.333h2.667c.184 0 .333.149.333.333v2a.333.333 0 1 1-.666 0V2.307h-2v1.667a.333.333 0 1 1-.667 0v-2Z" />
      </g>
    </svg>
  );
};

ChargeCable.category = 'product-category';

ChargeCable.displayName = 'ChargeCable';
